import { AccessTypes } from '../atoms/Creation'
import AmplitudeEvent from './AmplitudeEvent'
import { getPageName } from './utils'

// =============================================================================
// Abstract base class for all creation events
// =============================================================================

abstract class CreationAmplitudeEvent extends AmplitudeEvent {
  category = 'creation'
}

// =============================================================================
// Creation events (for descriptions, see the Notion doc)
// =============================================================================

export class ClickStudioEvent extends CreationAmplitudeEvent {
  name = 'click studio'

  constructor(path: string) {
    super()
    this.properties = {
      page: getPageName(path),
    }
  }
}

export class ClickNewVideoEvent extends CreationAmplitudeEvent {
  name = 'click new video'
}

export class SelectedVisibilityEvent extends CreationAmplitudeEvent {
  name = 'selected visibility'

  constructor(type: AccessTypes) {
    super()
    this.properties = {
      type: type === AccessTypes.FREE ? 'free to watch' : 'token gated',
    }
  }
}

export class UploadedVideoEvent extends CreationAmplitudeEvent {
  name = 'uploaded video'

  constructor(type: string, size: number) {
    super()
    this.properties = {
      type,
      size,
    }
  }
}

export class SubmittedVideoDetailsEvent extends CreationAmplitudeEvent {
  name = 'submitted video details'
}

export class SubmittedMonetizationDetailsEvent extends CreationAmplitudeEvent {
  name = 'submitted monetization details'

  constructor(price: number, min_editions: number, max_editions: number) {
    super()
    this.properties = {
      price,
      min_editions,
      max_editions,
    }
  }
}

export class SubmittedDropTimeEvent extends CreationAmplitudeEvent {
  name = 'submitted drop time'
  constructor(hoursFromNow: number) {
    super()
    this.properties = {
      hoursFromNow,
    }
  }
}

export class VerifiedKYCEvent extends CreationAmplitudeEvent {
  name = 'verified KYC'
}

export class ProcessedVideoEvent extends CreationAmplitudeEvent {
  name = 'processed video'
}

export class ProcessingVideoFailedEvent extends CreationAmplitudeEvent {
  name = 'failed processing video'
}

export class MintedEvent extends CreationAmplitudeEvent {
  name = 'minted video'
}

export class MintFailedEvent extends CreationAmplitudeEvent {
  name = 'failed minting video'

  constructor(reason: string) {
    super()
    this.properties = {
      reason,
    }
  }
}

export class ClickWatchEvent extends CreationAmplitudeEvent {
  name = 'click watch after creation'
}

export class ClickShareToTwitterEvent extends CreationAmplitudeEvent {
  name = 'click twitter share after creation'
}

export class ClickCopyLinkEvent extends CreationAmplitudeEvent {
  name = 'click copy link after creation'
}

export class ClickViewProfileEvent extends CreationAmplitudeEvent {
  name = 'click view profile after creation'
}
